var Ntss;
(function (Ntss) {
    const appInsights = window["appInsights"];
    function _removeExceptionDataIfRequired(...args) {
        const shouldNotDisplayExceptions = (!Ntss.isDebugging && !Ntss.displayExceptions);
        if (!_.isNil(args["exceptionData"]) && shouldNotDisplayExceptions) {
            delete args["exceptionData"];
        }
        if (!_.isNil(args["exceptionMessage"]) && shouldNotDisplayExceptions) {
            delete args["exceptionMessage"];
        }
    }
    function log(...args) {
        // Make sure we have at least one parameter passed in and make sure we are "allowed" to write to the console
        if ((_.isNil(args) || args.length < 1) || (!Ntss.isDebugging && !Ntss.displayLogging)) {
            return;
        }
        console.log("\n");
        _removeExceptionDataIfRequired(args);
        _.forEach(args, item => {
            console.log(item);
        });
    }
    function info(...args) {
        // Make sure we have at least one parameter passed in and make sure we are "allowed" to write to the console
        if ((_.isNil(args) || args.length < 1) || (!Ntss.isDebugging && !Ntss.displayLogging)) {
            return;
        }
        console.log("\n");
        _removeExceptionDataIfRequired(args);
        _.forEach(args, item => {
            console.info(item);
        });
    }
    function warn(...args) {
        // Make sure we have at least one parameter passed in and make sure we are "allowed" to write to the console
        if ((_.isNil(args) || args.length < 1) || (!Ntss.isDebugging && !Ntss.displayLogging)) {
            return;
        }
        console.log("\n");
        _removeExceptionDataIfRequired(args);
        _.forEach(args, item => {
            console.warn(item);
        });
    }
    function error(...args) {
        // Make sure we have at least one parameter passed in and make sure we are "allowed" to write to the console
        if ((_.isNil(args) || args.length < 1) || (!Ntss.isDebugging && !Ntss.displayLogging)) {
            return;
        }
        console.log("\n");
        // Extracting out the arguments into application insights properties object
        let aiProps = {};
        _.forEach(args, (a, index) => {
            const propName = `arg_${index}`;
            aiProps[propName] = a;
        });
        _removeExceptionDataIfRequired(args);
        _.forEach(args, (a) => {
            console.log(a);
        });
        // Send this to Application Insights
        appInsights.trackEvent("LoggedError", aiProps);
    }
    function debug(...args) {
        // Make sure we have at least one parameter passed in and make sure we are "allowed" to write to the console
        if ((_.isNil(args) || args.length < 1) || (!Ntss.isDebugging && !Ntss.displayLogging)) {
            return;
        }
        console.log("\n");
        _removeExceptionDataIfRequired(args);
        _.forEach(args, (a) => {
            console.debug(a);
        });
    }
    Ntss.ntssLogger = {
        log: log,
        info: info,
        warn: warn,
        error: error,
        debug: debug
    };
})(Ntss || (Ntss = {}));
